const 
    thHeaders = ['Server Name', 'Server Status', 'Ping Number', 'Medium Download Speed', 'Max Download Speed'],
    tdNames = ['server-name', 'server-status', 'ping-number', 'medium-download-speed', 'max-download-speed'];
let
    headerIsSet = false;

const addToTable = (hostName, pingNumber) => {
    const newRow = document.createElement(`tr`);
    newRow.id = `${hostName}-${pingNumber}`;

    for (var i = 0; i < tdNames.length; i++) {
        const newTd = document.createElement('td');

        newTd.id = `${hostName}-${pingNumber}-${tdNames[i]}`;
        newTd.classList.add('benchmark-table-cell');

        if(tdNames[i] == tdNames[2]) {
            newTd.classList.add('benchmark-table-ping-number');
        } //to temporary hide column of pings

        newRow.appendChild(newTd);
    }

    const mainTable = document.getElementById('request-table');
    mainTable.appendChild(newRow);
}

const setViewForUrl = (headerText) => {
    if(!headerIsSet) {
        const header = document.createElement('h2');
        header.innerText = headerText;
        document.getElementsByTagName('body')[0].insertBefore(header, document.getElementById('request-table'));

        document.getElementById('table-summarize').classList.add('table-hide');

        headerIsSet = true;
    }
}

export class ViewChanger{ 
    initTable(hostName, pingsNumber) {
        addToTable(hostName, pingsNumber)

        for(var i = 0; i < pingsNumber; i++) {
            this.updateTable(hostName, i+1, 0, 0)
        } //init table values
    }

    initTableFromUrl(server) {
        addToTable(server.hostName, server.pingIndex);

        this.updateTable(server.hostName, server.pingIndex, server.averageDownloadSpeed, server.maxDownloadSpeed);

        this.updateServerRequestStatus(server.hostName, server.pingIndex, 'url data');

        setViewForUrl("There are NOT your results, you're viewing someone's else data.");
    }

    updateTable(hostName, pingNumber, downloadSpeed, maxDownloadSpeed) {
        if(hostName == undefined || pingNumber == undefined || hostName == null || pingNumber == null) {
            return new Error("can't update table without host name or ping number");
        }

        if(hostName != undefined && hostName != null) {
            const tdToUpdate = document.getElementById(`${hostName}-${pingNumber}-${tdNames[0]}`)

            tdToUpdate.innerText = hostName;
        }

        if(pingNumber != undefined && pingNumber != null) {
            const tdToUpdate = document.getElementById(`${hostName}-${pingNumber}-${tdNames[2]}`)

            tdToUpdate.innerText = pingNumber;
        }
        
        if(downloadSpeed != undefined && downloadSpeed != null) {
            const tdToUpdate = document.getElementById(`${hostName}-${pingNumber}-${tdNames[3]}`)

            tdToUpdate.innerText = downloadSpeed + ' Mb/s';
        }

        if(maxDownloadSpeed != undefined && maxDownloadSpeed != null) {
            const tdToUpdate = document.getElementById(`${hostName}-${pingNumber}-${tdNames[4]}`)

            tdToUpdate.innerText = maxDownloadSpeed + ' Mb/s';
        }
    }

    updateServerRequestStatus(hostName, pingIndex, statusMassage) {
        const tdToUpdate = document.getElementById(`${hostName}-${pingIndex}-${tdNames[1]}`);

        tdToUpdate.innerText = statusMassage;
    }

    addSummarizeUrl(url) {
        const 
            urlInput = document.getElementById('table-summarize-input'),
            urlInputButton = document.getElementById('table-summarize-button');

        urlInput.value = url;
        urlInputButton.disabled = false;
    }

    updateUserInfo(userInfo) {
        if(userInfo) {
            const 
            userId = document.getElementById('benchmark-table-user-ip'),
            userHost = document.getElementById('benchmark-table-user-host'),
            userCountry = document.getElementById('benchmark-table-user-country');

        userId.innerText = userInfo.userIp;
        // userHost.innerText = userInfo.userHost;
        userCountry.innerText = userInfo.userCountry;
        }
    }
}